import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getProcedureDetails } from '../utils/urls';

import { ProcedureInfoType } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchProcedureDetails({
  accountId,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getProcedureDetails(accountId, procedureId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: ProcedureInfoType;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number | undefined;
  procedureId: number | undefined;
};

function useGetProcedureDetails({
  accountId,
  procedureId,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedure', accountId, procedureId],
    async () => {
      if (!accountId || !procedureId) return;
      const apiResult = await fetchProcedureDetails({
        accountId,
        procedureId,
      });
      return apiResult;
    },

    {
      staleTime: Infinity,
    },
  );
}

export { useGetProcedureDetails };
